import React from "react";
import {
  Pagination,
  PaginationProps,
  Table,
  TablePaginationConfig,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import { FilterValue, SorterResult } from "antd/es/table/interface";

interface TableComponentProps<T> {
  columns: ColumnsType<T>;
  data: T[];
  loading?: boolean;
  pagination?: TablePaginationConfig;
  rowClassName?: (record: T) => string;
  rowKey?: string | ((record: T) => string);
  onTableChange?: (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<T> | SorterResult<T>[]
  ) => void;
}

const DataTable = <T extends object>({
  columns,
  data,
  loading = false,
  rowKey = "id",
  pagination,
  rowClassName,
  onTableChange,
}: TableComponentProps<T>) => {
  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
        rowClassName={rowClassName}
        rowKey={rowKey}
        onChange={onTableChange}
        components={{
          header: {
            cell: (props: any) => (
              <th
                {...props}
                style={{
                  backgroundColor: "#111",
                  color: "white",
                  padding: "10px",
                  borderBottom: "1px solid #444",
                }}
              />
            ),
          },
          body: {
            row: (props: any) => <tr {...props} />,
            cell: (props: any) => <td {...props} />,
          },
        }}
      />

      {/* Pagination Container - Aligning it to the left */}
      <div
        style={{
          marginTop: "auto",
          padding: "10px",
          display: "flex",
          justifyContent: "flex-start", // Align to left
        }}
        className="custom-pagination-wrapper"
      >
        <Pagination
          current={pagination?.current || 1}
          pageSize={pagination?.pageSize || 10}
          total={pagination?.total || 0}
          onChange={(page, pageSize) => {
            if (onTableChange) {
              onTableChange(
                { ...pagination, current: page, pageSize: pageSize },
                {}, // No filters
                [] // No sorter
              );
            }
          }}
          itemRender={itemRender}
          // showTotal={(total) => `Total ${total} items`}
        />
      </div>
    </>
  );
};

export default DataTable;

// Custom Pagination Renderer
const itemRender: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if (type === "prev") {
    return <a>Previous</a>;
  }
  if (type === "next") {
    return <a>Next</a>;
  }
  return originalElement;
};
